const httpLib = require('./http-library.js');
const publicConfig = require('../public-config.js');
const entitlementsHost = publicConfig.external_address;

exports.Entitlements = {

  createAttachment (entitlementId, ssoId, token, callback) {
    const attachBody = {
      entitlement_id: entitlementId,
      ns: 'profiles',
      key: 'SSOid',
      value: ssoId
    };

    const requestParams = {
      host: entitlementsHost,
      path: '/v1/entitlements/attachments',
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      }
    };

    httpLib.request(requestParams, function (response) {
      callback(response);
    }, attachBody);
  },

  readEntitlement (externalId, callback) {
    const requestParams = {
      host: entitlementsHost,
      path: '/v1/entitlements/external_id/' + externalId,
      method: 'GET'
    };

    httpLib.request(requestParams, function (response) {
      callback(response);
    }, null);
  },

  readUserEntitlement (ssoId, token, callback) {
    const requestParams = {
      host: entitlementsHost,
      path: '/v1/entitlements/attachments/profiles/' + ssoId,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      }
    };

    httpLib.request(requestParams, function (response) {
      callback(response);
    }, null);
  },

  readEntitlementQuery (query, accessToken, callback) {
    const requestParams = {
      host: entitlementsHost,
      path: `/v1/entitlements?${query}`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + accessToken
      }
    };

    httpLib.request(requestParams, function (response) {
      callback(response);
    }, null);
  }

};
